import { Component, OnInit } from '@angular/core';
import { LicenseBundleResponse, LicenseResponse } from '@app/models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-activation-success-dialog',
  templateUrl: './activation-success-dialog.component.html',
  styleUrls: ['./activation-success-dialog.component.scss'],
})
export class ActivationSuccessDialogComponent implements OnInit {
  licenses: LicenseResponse[];
  licenseBundle?: LicenseBundleResponse;

  get offlineLicenseKey(): string {
    return this.licenseBundle?.offlineLicenseKey ?? this.licenses[0].offlineLicenseKey;
  }

  get offlineLicenseKeyExpirationTime(): Date {
    return this.licenseBundle?.offlineLicenseKeyExpirationTime ?? this.licenses[0].offlineLicenseKeyExpirationTime;
  }

  constructor(
    { data }: DynamicDialogConfig,
    public ref: DynamicDialogRef,
  ) {
    this.licenses = data.licenses;
    this.licenseBundle = data.licenseBundle;
  }

  ngOnInit(): void {
    // if (!this.licenseBundle) return;

    // for (const license of this.licenses) {
    //   license.licenseBundle = this.licenseBundle;
    // }
  }
}
